module.exports = {
	"13": {
		"4": "Visa"
	},
	"14": {
		"36": "Diners Club",
		"38": "Carte Blanche",
		"300": "Diners Club",
		"301": "Diners Club",
		"302": "Diners Club",
		"303": "Diners Club",
		"304": "Diners Club",
		"305": "Diners Club"
	},
	"15": {
		"34": "American Express",
		"37": "American Express",
		"1800": "JCB",
		"2014": "EnRoute",
		"2131": "JCB",
		"2149": "EnRoute"
	},
	"16": {
		"3": "JCB",
		"4": "Visa",
		"51": "Master Card",
		"52": "Master Card",
		"53": "Master Card",
		"54": "Master Card",
		"55": "Master Card",
		"6011": "Discover"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/card-swipe/card_type.json
// module id = 1737
// module chunks = 0